const fetchProducts = (categorySlug) => {
	return fetch('/wp/wp-admin/admin-ajax.php', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		},
		body: new URLSearchParams({
			action: 'tedee_filter_archive_products',
			type: 'product',
			category: categorySlug,
		}),
	}).then(response => response.text());
};

const productFilters = () => {
	const activeClass = 'product-filters__item--active';
	const filterButtons = document.querySelectorAll('.product-filters__item');
	const productsContainer = document.getElementById('archive-products__loop-wrapper');

	filterButtons.forEach((button) => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			filterButtons.forEach((btn) => btn.classList.remove(activeClass));
			button.classList.add(activeClass);
			productsContainer.classList.add('loading-skeleton');

			let filtersContainerHeight = document.querySelector('.archive-products__filters').clientHeight;

			fetchProducts(button.dataset.slug)
				.then(html => {
					productsContainer.innerHTML = html;
					productsContainer.classList.remove('loading-skeleton');

					let navHeight = document.documentElement.style.getPropertyValue('--navHeight')
					let navHeightVal = navHeight.replace('px', '')
					let sum = Number(navHeightVal) + Number(filtersContainerHeight)
					window.scrollTo({
						top: sum,
						behavior: "smooth"
					})
				});
		});
	});
};

export default productFilters;
